module.exports = __webpack_public_path__ + "img/ecosystem_cloud_right.d728a64b.png";